import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ContactCta from "./sections/ContactCta";
import Footer from "@/reusable_sections/Footer";
import ServiceCards from "./sections/ServiceCards";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServiceCards />
      <ContactCta />
      <Footer />
    </div>;
}